module.exports = __webpack_public_path__ + "user.72da5ab5.svg";